/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductManufacturer
 */
export interface ProductManufacturer {
    /**
     * 
     * @type {string}
     * @memberof ProductManufacturer
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ProductManufacturer
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof ProductManufacturer
     */
    name: string;
}

/**
 * Check if a given object implements the ProductManufacturer interface.
 */
export function instanceOfProductManufacturer(value: object): value is ProductManufacturer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ProductManufacturerFromJSON(json: any): ProductManufacturer {
    return ProductManufacturerFromJSONTyped(json, false);
}

export function ProductManufacturerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductManufacturer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'name': json['name'],
    };
}

export function ProductManufacturerToJSON(json: any): ProductManufacturer {
    return ProductManufacturerToJSONTyped(json, false);
}

export function ProductManufacturerToJSONTyped(value?: ProductManufacturer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': value['number'],
        'name': value['name'],
    };
}

